import { fromJS } from 'immutable';
import TaxProfileActions from '../actions/TaxProfileActions';
import {getError} from '../utils/Utils';
import {TAX_PROFILE_STATUS} from '../constants/PaymentStatus';

const {
    GET_TAX_PROFILE,
    GET_TAX_PROFILE_SUCCESS,
    GET_TAX_PROFILE_FAILED,
    UPDATE_TAX_PROFILE,
    UPDATE_TAX_PROFILE_SUCCESS,
    UPDATE_TAX_PROFILE_FAILED,
    PULL_TAX_PROFILE,
    PULL_TAX_PROFILE_SUCCESS,
    PULL_TAX_PROFILE_FAILED,
    FETCH_PROFILE_UPDATES,
    GET_INTERVIEW,
    GET_INTERVIEW_SUCCESS,
    GET_INTERVIEW_FAILED,
    SET_FORM,
    GET_PAYOUT_ACCOUNT_STATUS,
    GET_PAYOUT_ACCOUNT_STATUS_SUCCESS,
    GET_TAX_DOCUMENTS_SUCCESS,
    SET_TAX_DOC_REQ_COUNT,
    GET_PAYOUT_ACCOUNT_STATUS_FAILED,
    GET_RETAKE_AVAILABLE,
    GET_RETAKE_AVAILABLE_SUCCESS,
    GET_RETAKE_AVAILABLE_FAILED,
    GET_CONSENT_INTERVIEW,
    GET_CONSENT_INTERVIEW_SUCCESS,
    GET_CONSENT_INTERVIEW_FAILED,
    RESET_INTERVIEW_CURRENT_URL,
    RESET_INTERVIEW_FAILED,
    SET_TAX_DOC_REQ_STATUS
} = TaxProfileActions.TYPES;

const DEFAULT_STATE = fromJS({
    form: {
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        tin: '',
        addressCity: '',
        addressCountry: '',
        addressState: '',
        addressPostCode: ''
    },
    url: '',
    currentUrl: '',
    loading: true,
    submitting: false,
    wasUpdated: false,
    loadingUrl: true,
    isValidated: true,
    accountStatus: '',
    status: null,
    taxDocuments: null,
    yearLength: 7,
    taxDocReqCount: 0,
    retakeAvailable: false,
    error: {
        fetchUrlFailed: false
    },
    taxDocRequestStatus: 'idle' // 'idle' | 'loading' | 'success' | 'error'
});


export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case GET_CONSENT_INTERVIEW: {
            newState = newState.updateIn(['loadingUrl'], () => true);
            return newState;
        }
        case GET_CONSENT_INTERVIEW_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['loadingUrl'], () => false);
            newState = newState.updateIn(['currentUrl'], () => payload && payload.taxInterviewURL);
            return newState;
        }
        case GET_CONSENT_INTERVIEW_FAILED: {
            newState = newState.updateIn(['loadingUrl'], () => false);
            newState = newState.updateIn(['error', 'fetchUrlFailed'], () => true);
            return newState;
        }
        case GET_RETAKE_AVAILABLE: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case GET_RETAKE_AVAILABLE_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['retakeAvailable'], () => payload.available);
            return newState;
        }
        case GET_RETAKE_AVAILABLE_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case GET_TAX_PROFILE: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case GET_TAX_PROFILE_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['form'], () => payload);
            newState = newState.updateIn(['status'], () => payload.taxStatus);
            if (!payload.recordIdentityKey) {
                newState = newState.updateIn(['status'], () => TAX_PROFILE_STATUS.NULL);
            }
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['wasFetched'], () => true);
            return newState;
        }
        case GET_TAX_PROFILE_FAILED: {
            const error = getError({error: action.payload});
            if (error.status === 'Error' && (error.errorCode === 'errors.com.epicgames.ecommerce.payout.invalid_tax_identity')) {
                newState = newState.updateIn(['status'], () => TAX_PROFILE_STATUS.NULL);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case UPDATE_TAX_PROFILE: {
            newState = newState.updateIn(['loading'], () => true);
            newState = newState.updateIn(['wasUpdated'], () => false);
            return newState;
        }
        case UPDATE_TAX_PROFILE_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['form'], () => payload);
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['wasUpdated'], () => true);
            return newState;
        }
        case UPDATE_TAX_PROFILE_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['wasUpdated'], () => false);
            return newState;
        }

        case PULL_TAX_PROFILE: {
            return newState;
        }
        case PULL_TAX_PROFILE_SUCCESS: {
            return newState;
        }
        case PULL_TAX_PROFILE_FAILED: {
            return newState;
        }

        case FETCH_PROFILE_UPDATES: {
            newState = newState.updateIn(['wasFetched'], () => false);
            return newState;
        }

        case GET_INTERVIEW: {
            newState = newState.updateIn(['submitting'], () => true);
            newState = newState.updateIn(['loadingUrl'], () => true);
            return newState;
        }
        case GET_INTERVIEW_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['submitting'], () => false);
            newState = newState.updateIn(['loadingUrl'], () => false);
            newState = newState.updateIn(['currentUrl'], () => payload && payload.taxInterviewURL);
            return newState;
        }
        case GET_INTERVIEW_FAILED: {
            newState = newState.updateIn(['loadingUrl'], () => false);
            newState = newState.updateIn(['submitting'], () => false);
            newState = newState.updateIn(['error', 'fetchUrlFailed'], () => true);
            return newState;
        }
        case SET_FORM: {
            const payload = action.payload;
            newState = newState.updateIn(['form'], () => payload);
            return newState;
        }

        case GET_PAYOUT_ACCOUNT_STATUS: {
            return newState;
        }

        case GET_PAYOUT_ACCOUNT_STATUS_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['accountStatus'], () => payload && payload.accountStatus);
            return newState;
        }

        case GET_PAYOUT_ACCOUNT_STATUS_FAILED: {
            return newState;
        }

        case GET_TAX_DOCUMENTS_SUCCESS: {
            const payload = action.payload;
            newState = newState.updateIn(['taxDocuments'], () => payload.documents);
            newState = newState.updateIn(['yearLength'], () => payload.yearLength);
            return newState;
        }

        case SET_TAX_DOC_REQ_COUNT: {
            newState = newState.updateIn(['taxDocReqCount'], () => action.payload);
            return newState;
        }

        case RESET_INTERVIEW_FAILED: {
            newState = newState.updateIn(['error', 'fetchUrlFailed'], () => false);
            return newState;
        }

        case RESET_INTERVIEW_CURRENT_URL: {
            newState = newState.updateIn(['currentUrl'], () => '');
            return newState;
        }

        case SET_TAX_DOC_REQ_STATUS: {
            const payload = action.payload;
            newState = newState.updateIn(['taxDocRequestStatus'], () => payload);
            return newState;
        }

        default: return newState;
    }
}
